import { defineMessages } from 'react-intl';
import { TRANSLATIONS_ROOT } from './constants';

const messages = defineMessages({
  divisionSpecialityShop: {
    id: 'divisionSpecialityShop',
    defaultMessage: 'Division/Speciality Shop',
  },
  specialityShopRangeGroup: {
    id: 'specialityShopRangeGroup',
    defaultMessage: 'Speciality Shop/Range Group',
  },
  rangeGroupPA: {
    id: 'rangeGroupPA',
    defaultMessage: 'Range Group/PA',
  },
  rangeGroupSLID: {
    id: 'rangeGroupSLID',
    defaultMessage: 'Range Group/SL-ID',
  },
  division: {
    id: 'division',
    defaultMessage: 'Division',
  },
  specialityShop: {
    id: 'specialityShop',
    defaultMessage: 'Speciality Shop',
  },
  rangeGroup: {
    id: 'rangeGroup',
    defaultMessage: 'Range Group',
  },
  salesSpaceQuantityVolume: {
    id: 'salesSpaceQuantityVolume',
    defaultMessage: 'SSQ Volume (m3)',
  },
  plannedMaxDensity: {
    id: 'plannedMaxDensity',
    defaultMessage: 'Planned Max Density',
  },
  areaM2: {
    id: 'areaM2',
    defaultMessage: 'Area (m2)',
  },
  plannedFillingRate: {
    id: 'plannedFillingRate',
    defaultMessage: 'Planned Filling Rate (%)',
  },
  maxDensity: {
    id: 'maxDensity',
    defaultMessage: 'Max Density',
  },
  plannedDensity: {
    id: 'plannedDensity',
    defaultMessage: 'Planned Density',
  },
  selectDivisionTitle: {
    id: 'selectDivisionTitle',
    defaultMessage: 'Select Division',
  },
  selectDivisionBody: {
    id: 'selectDivisionBody',
    defaultMessage: 'Please select a Division.',
  },
  selectSpecialityShopTitle: {
    id: 'selectSpecialityShopTitle',
    defaultMessage: 'Select Speciality Shop',
  },
  selectSpecialityShopBody: {
    id: 'selectSpecialityShopBody',
    defaultMessage: 'Please select a Division and Speciality Shop.',
  },
  specialityShopsHeading: {
    id: 'specialityShopsHeading',
    defaultMessage: 'Connected Speciality Shops',
  },
  specialityShopsHelpHeader: {
    id: 'specialityShopsHelpHeading',
    defaultMessage: 'Connected Speciality Shops',
  },
  specialityShopsHelpBody: {
    id: 'specialityShopsHelpBody',
    defaultMessage: 'Help text for speciality shops.',
  },
  editSpecialityShopTitle: {
    id: 'editSpecialityShopTitle',
    defaultMessage: 'Edit Speciality Shop',
  },
  removeSpecialityShopTitle: {
    id: 'removeSpecialityShopTitle',
    defaultMessage: 'Remove Speciality Shop',
  },
  removeSpecialityShopBody: {
    id: 'removeSpecialityShopBody',
    defaultMessage: 'Are you sure you want to remove this Speciality Shop?',
  },
  addSpecialityShop: {
    id: 'addSpecialityShop',
    defaultMessage: 'Add Speciality Shop',
  },

  rangeGroupsHeading: {
    id: 'rangeGroupsHeading',
    defaultMessage: 'Connected Range Groups',
  },
  rangeGroupsHelpBody: {
    id: 'rangeGroupsHelpBody',
    defaultMessage: 'Help text for speciality shops.',
  },
  editRangeGroupTitle: {
    id: 'editRangeGroupTitle',
    defaultMessage: 'Edit Range Group',
  },
  removeRangeGroupTitle: {
    id: 'removeRangeGroupTitle',
    defaultMessage: 'Remove Range Group',
  },
  removeRangeGroupBody: {
    id: 'removeRangeGroupBody',
    defaultMessage: 'Are you sure you want to remove this Range Group?',
  },
  addRangeGroup: {
    id: 'addRangeGroup',
    defaultMessage: 'Add Range Group',
  },
  paShort: {
    id: 'paShort',
    defaultMessage: 'PA',
  },
  paLong: {
    id: 'paLong',
    defaultMessage: 'Product area',
  },
  paAssignedListTitle: {
    id: 'paAssignedListTitle',
    defaultMessage: 'Connected PAs',
  },
  paAssignedListTitleTooltip: {
    id: 'paAssignedListTitleTooltip',
    defaultMessage: 'Connected Product Areas',
  },
  paUnassignedListTitle: {
    id: 'paUnassignedListTitle',
    defaultMessage: 'Remaining PAs',
  },
  paUnassignedListTitleTooltip: {
    id: 'paUnassignedListTitleTooltip',
    defaultMessage: 'Remaining Product Areas',
  },

  slidAssignedListTitle: {
    id: 'slidAssignedListTitle',
    defaultMessage: 'Connected SL-IDs',
  },
  slidAssignedListTitleTooltip: {
    id: 'slidAssignedListTitleTooltip',
    defaultMessage: 'Connected Sales Location IDs',
  },
  slidUnassignedListTitle: {
    id: 'slidUnassignedListTitle',
    defaultMessage: 'Remaining SL-IDs',
  },
  slidUnassignedListTitleTooltip: {
    id: 'slidUnassignedListTitleTooltip',
    defaultMessage: 'Remaining Sales Location IDs',
  },
  newSlid: {
    id: 'newSlid',
    defaultMessage: 'New SL-ID',
  },
  slidShort: {
    id: 'slidShort',
    defaultMessage: 'SL-ID',
    description: 'Sales Location ID, abbreviated',
  },
  slidLong: {
    id: 'slidLong',
    defaultMessage: 'Sales Location ID',
  },
  newSlidModalInputDescription: {
    id: 'newSlidModalInputDescription',
    defaultMessage: 'SL-ID Description',
  },
  assignerAssignTooltip: {
    id: 'assignerAssignTooltip',
    defaultMessage: 'Add',
  },
  assignerUnassignTooltip: {
    id: 'assignerUnassignTooltip',
    defaultMessage: 'Remove',
  },
  assignerReassignTooltip: {
    id: 'assignerReassignTooltip',
    defaultMessage: 'Assign to another Range Group',
  },
  assignerUnassignedPAsWarningArtWithFcTooltip: {
    id: 'assignerUnassignedPAsWarningArtWithFcTooltip',
    defaultMessage:
      'Some Product Areas have articles with forecast. The articles will not be available/calculated correctly until the PAs are assigned.',
    description:
      'Addendum to the Remaining PAs tooltip, warning that some PAs have articles with forecast, informing the coworker that the articles will not be functioning correctly until the affected PAs are assigned.',
  },
  paHasArticlesWithForecast: {
    id: 'paHasArticlesWithForecast',
    defaultMessage: 'Not Empty',
    description:
      'Indicates that the Product Area has articles with forecast, and is not empty.',
  },
  paHasArticlesWithForecastTooltip: {
    id: 'paHasArticlesWithForecastTooltip',
    defaultMessage: 'Articles with forecast.',
    description:
      'Tooltip for the "Not Empty" indicator, indicating that the Product Area has articles with forecast.',
  },
});

const constraintMessages = defineMessages({
  DivisionAreaM2: {
    id: 'DivisionAreaM2',
    defaultMessage:
      'The Division area of {divisionAreaM2} m2 cannot be less than the sum of the areas of the Speciality Shops {specialityShopsAreaM2} m2',
  },
  UniqueName: {
    id: 'UniqueName',
    defaultMessage: 'The name {name} is already in use.',
  },
  SlidOfIncorrectType: {
    id: 'slidOfIncorrectType',
    defaultMessage: 'This action is not allowed for this type of SL-ID',
    description: 'Error message when SLID is of incorrect type for the action',
  },
});

const useCaseMessages = {
  updateDivision: defineMessages({
    success: {
      id: 'updateDivisionSuccess',
      defaultMessage: 'Updated Division: {name}',
    },
    error: {
      id: 'updateDivisionError',
      defaultMessage: 'Error updating Division: {name}',
    },
  }),
  addSpecialityShop: defineMessages({
    success: {
      id: 'addSpecialityShopSuccess',
      defaultMessage: 'Added Speciality Shop: {name}',
    },
    error: {
      id: 'addSpecialityShopError',
      defaultMessage: 'Error adding Speciality Shop: {name}',
    },
  }),
  editSpecialityShop: defineMessages({
    success: {
      id: 'editSpecialityShopSuccess',
      defaultMessage: 'Renamed Speciality Shop: {name}',
    },
    error: {
      id: 'editSpecialityShopError',
      defaultMessage: 'Error renaming Speciality Shop: {currentName}',
    },
  }),
  removeSpecialityShop: defineMessages({
    success: {
      id: 'removeSpecialityShopSuccess',
      defaultMessage: 'Removed Speciality Shop: {name}',
    },
    error: {
      id: 'removeSpecialityShopError',
      defaultMessage: 'Error removing Speciality Shop: {name}',
    },
  }),
  toggleSpecialityShopVisibility: defineMessages({
    error: {
      id: 'toggleSpecialityShopVisibilityError',
      defaultMessage: 'Error hiding/showing Speciality Shop: {name}',
    },
  }),
  updateSpecialityShop: defineMessages({
    success: {
      id: 'updateSpecialityShop',
      defaultMessage: 'Updated Speciality Shop: {name}',
    },
    error: {
      id: 'updateSpecialityShopError',
      defaultMessage: 'Error updating Speciality Shop: {name}',
    },
  }),
  updateRangeGroup: defineMessages({
    success: {
      id: 'updateRangeGroupSuccess',
      defaultMessage: 'Updated Range Group: {name}',
    },
    error: {
      id: 'updateRangeGroupError',
      defaultMessage: 'Error updating Range Group: {name}',
    },
  }),
  addRangeGroup: defineMessages({
    success: {
      id: 'addRangeGroupSuccess',
      defaultMessage: 'Added Range Group: {name}',
    },
    error: {
      id: 'addRangeGroupError',
      defaultMessage: 'Error adding Range Group: {name}',
    },
  }),
  editRangeGroup: defineMessages({
    success: {
      id: 'editRangeGroupSuccess',
      defaultMessage: 'Renamed Range Group: {name}',
    },
    error: {
      id: 'editRangeGroupError',
      defaultMessage: 'Error renaming Range Group: {currentName}',
    },
  }),
  removeRangeGroup: defineMessages({
    success: {
      id: 'removeRangeGroupSuccess',
      defaultMessage: 'Removed Range Group: {name}',
    },
    error: {
      id: 'removeRangeGroupError',
      defaultMessage: 'Error removing Range Group: {name}',
    },
    Integrity: {
      id: 'removeRangeGroupIntegrity',
      defaultMessage:
        'Cannot hide Range Group {name}, because it has a Product Area or Sales Location connected to it.',
    },
  }),
  toggleRangeGroupVisibility: defineMessages({
    error: {
      id: 'toggleRangeGroupVisibilityError',
      defaultMessage: 'Error hiding/showing Range Group: {name}',
    },
    Integrity: {
      id: 'Integrity',
      defaultMessage:
        'Cannot show/hide Range Group, because it has a Product Area or Sales Location connected to it.',
    },
  }),
  addSlid: defineMessages({
    success: {
      id: 'addSlidSuccess',
      defaultMessage: 'Added SL-ID: {id}',
    },
    error: {
      id: 'addSlidError',
      defaultMessage: 'Error adding SL-ID: {id}',
    },
    UniqueName: {
      id: 'addSlidErrorUniqueName',
      defaultMessage: 'The SL-ID {id} is already in use.',
    },
  }),
  removeSlid: defineMessages({
    success: {
      id: 'removeSlidSuccess',
      defaultMessage: 'Removed SL-ID: {id}',
    },
    error: {
      id: 'removeSlidError',
      defaultMessage: 'Error removing SL-ID: {id}',
    },
  }),
  reassignSlidToNewRg: defineMessages({
    success: {
      id: 'reassignSlidToNewRgSuccess',
      defaultMessage: 'Successfully reassigned SL-ID {id} to new Range Group',
    },
    error: {
      id: 'reassignSlidToNewRgError',
      defaultMessage: 'Failed to reassign SL-ID {id} to new Range Group',
    },
  }),
  reassignPAToNewRg: defineMessages({
    success: {
      id: 'reassignPAToNewRgSuccess',
      defaultMessage: 'Successfully moved PA {id} to new Range Group',
    },
    error: {
      id: 'reassignPAToNewRgError',
      defaultMessage: 'Failed to move PA {id} to new Range Group',
    },
  }),
  changedSlidAssignment: defineMessages({
    success: {
      id: 'assignSlidSuccess',
      defaultMessage: 'Changed assignment of SL-ID: {id}',
    },
    error: {
      id: 'assignSlidError',
      defaultMessage: 'Failed to change assignment of SL-ID: {id}',
    },
  }),
};

const storeStructureMessages = {
  ...messages,
  ...{ constraints: constraintMessages },
  ...{ useCases: useCaseMessages },
};

export type StructureItem = {
  name: string;
  value: string;
};

export const buildStructureItemMessage = (structureItem: StructureItem) => ({
  id: `${TRANSLATIONS_ROOT}.${structureItem.value}`,
  defaultMessage: structureItem.name,
});

export default storeStructureMessages;
